/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutRankingDevote.vue?vue&type=template&id=5475771f&scoped=true"
import script from "./LayoutRankingDevote.vue?vue&type=script&lang=js"
export * from "./LayoutRankingDevote.vue?vue&type=script&lang=js"
import style0 from "./LayoutRankingDevote.vue?vue&type=style&index=0&id=5475771f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475771f",
  null
  
)

export default component.exports